<template>
  <div class="container">
    <el-card class="mb-4">
      <div class="row d-flex">
        <el-card class="customer-list col-span-1 col-6 overflow-x-auto max-h-500">
          <div class="col-12 d-flex justify-content-end">
            <div class="col-8 d-flex align-items-end">
              <el-radio-group v-model="selectedPaymentMethod" @change="selectedPaymentMethodChanged"
                placeholder=" نوع الفاتوره" class="mb-0 p-0" style="direction: ltr;align-items:end;">
                <el-radio-button v-for="PM in paymentMethods" :label="PM.label" :value="PM.value" />
              </el-radio-group>
            </div>
          </div>

          <h2 class="text-lg font-semibold mb-0">الزبائن</h2>
          <div class="col-12 row d-flex flex-row p-2 py-0">
            <el-select v-model="buyerType" @change="fetchCustomers" placeholder=" نوع الزبون"
              class="mb-0 col-4 w-30 p-0">
              <el-option label="موظف" value="employee" />
              <el-option label="طالب" value="student" />
              <el-option label="زائر" value="visitor" />
            </el-select>

            <el-input ref="searchInput" v-model="searchQuery" placeholder="ابحث عن الزبون أو امسح الباركود"
            @input="filterCustomers" @change="filterCustomers" class="mb-0 col-8 w-70 p-0" />
          </div>
          <div class="table-wrapper">
            <el-table :data="filteredCustomers" border>
              <el-table-column prop="name" label="الاسم" />
              <el-table-column prop="daily_allowed_purchase_value" label="القيمة المسموحة" />
              <el-table-column prop="id" label="الرقم التعريفي" />
              <el-table-column label="الإجراء">
                <template #default="scope">
                  <el-button @click="selectCustomer(scope.row)" type="primary">اختر</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>

        <el-card v-if="selectedCustomer && selectedPaymentMethod"
          class="meal-section col-span-1 col-6 overflow-x-auto max-h-500 p-0">
          <p class="text-lg font-semibold mb-2">الزبون : {{ selectedCustomer.name }}</p>
          <div class="col-12">
            <div class="col-12">
              <label class="text-bold text-dark">التصنيفات</label>
              <el-radio-group v-model="selectedCategory" @change="filterMeals" placeholder=" نوع الفاتوره"
                class="mb-0 p-0" style="">
                <el-radio border v-for="category in categories" :key="category.id" :label="category.name"
                  :value="category.id" />
              </el-radio-group>
            </div>
            <div class="col-8">
              <label>...</label>
              <el-input v-model="mealSearchQuery" placeholder="ابحث عن الأصناف" @input="filterMeals" class="mb-4" />
            </div>
          </div>
          <p class="mb-2">اختر الأصناف:</p>
          <div class="table-wrapper">
            <el-table :data="filteredMeals" border>
              <el-table-column prop="name" label="اسم الصنف" />
              <el-table-column prop="price" width="70" label="السعر" />
              <el-table-column label="الإجراء" width="70">
                <template #default="scope">
                  <el-button @click="addToBill(scope.row)" type="success">+</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>

      <el-card v-if="selectedCustomer" class="bill-section col-span-1 overflow-x-auto max-h-500 row">
        <h2 class="text-lg font-semibold mt-0">الفاتورة</h2>
        <el-card>
          <h2 class="text-lg font-semibold mb-2 card">الزبون : {{ selectedCustomer.name }}</h2>
        </el-card>
        <div class="table-wrapper">
          <el-table :data="kitchenBillItems" border stripe>
            <el-table-column prop="name" label="اسم الصنف" width="300" />
            <el-table-column prop="quantity" label="الكمية">
              <template #default="scope">
                <div class="m-0 p-0 d-flex justify-content-between">
                  <el-button
                    @click="if (scope.row.quantity > 1) { scope.row.quantity--; } else { removeFromBill(scope.row.meal_id) }"
                    type="danger">-</el-button>
                  <label>{{ scope.row.quantity }}</label>
                  <el-button v-if="selectedPaymentMethod != 'subscription'" @click="scope.row.quantity++"
                    type="primary">+</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="meal_price" label="سعر القطعة" />
            <el-table-column prop="" label="السعر">
              <template #default="scope">
                {{ scope.row.meal_price * scope.row.quantity }}
              </template>
            </el-table-column>
            <el-table-column label="الإجراء">
              <template #default="scope">
                <el-button @click="removeFromBill(scope.row.meal_id)" type="danger">إزالة</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="d-flex flex-column align-items-end">
          <p class="font-bold mt-2">الإجمالي: {{ totalPrice }} دينار</p>
          <el-button v-if="selectedPaymentMethod != ''" @click="submitBill" type="success" class="mt-4 w-25"> تأكيد
            عملية
            البيع
          </el-button>
        </div>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { ElCard, ElSelect, ElOption, ElInput, ElTable, ElMessageBox, ElTableColumn, ElButton, ElNotification, ElMessage } from 'element-plus';
// We no longer need to import from 'vue-qrcode-reader'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api',
});

// Interceptors
api.interceptors.request.use((config) => {
  document.querySelectorAll('button').forEach((button) => {
    button.setAttribute('disabled', 'disabled');
  });
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

api.interceptors.response.use((response) => {
  document.querySelectorAll('button').forEach((button) => {
    button.removeAttribute('disabled');
  });
  return response;
}, (error) => {
  document.querySelectorAll('button').forEach((button) => {
    button.removeAttribute('disabled');
  });
  console.error("خطأ في الاستجابة:", error);
  return Promise.reject(error);
});

export default {
  components: {
    ElCard,
    ElSelect,
    ElOption,
    ElInput,
    ElTable,
    ElTableColumn,
    ElButton,
    ElMessageBox,
    ElNotification, // Added for error display
  },
  data() {
    return {
      scannedInput: '', // To accumulate characters from the barcode scanner
      scannedInputTimeout: null, // To reset the input buffer
      pinCheckStatus: false,
      pinCodeFromQR: "",
      customers: [],
      selectedCategory: null,
      categories: null,
      filteredCustomers: [],
      meals: [],
      filteredMeals: [],
      kitchenBillItems: [],
      buyerType: 'employee',
      selectedCustomer: null,
      searchQuery: '',
      mealSearchQuery: '',
      totalPriceValue: '',
      restrictedMealIds: [],
      paymentMethods: Array(),
      selectedPaymentMethod: "",
      allcategories: null,
      breakFastCategory: [{ id: 111, name: "وجبات افطار Caledonian" }],
      lunchCategory: [{ id: 222, name: "وجبات غداء Caledonian" }],
      breakFastAndlunchCategories: [
        { id: 111, name: "وجبات افطار Caledonian" },
        { id: 222, name: "وجبات غداء Caledonian" },
      ],
      visitorData: [{ id: null, name: null }],
    };
  },
  computed: {
    totalPrice() {
      this.totalPriceValue = this.kitchenBillItems.reduce((sum, item) => sum + item.meal_price * item.quantity, 0);
      return this.totalPriceValue;
    },
  },
  methods: {
    convertNumerals(str) {
      if (typeof str !== 'string') return str;
      const eastern = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
      const western = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      for (let i = 0; i < 10; i++) {
        str = str.replace(new RegExp(eastern[i], 'g'), western[i]);
      }
      return str;
    },
    // NEW: Handles keyboard events to capture barcode scanner input
    handleBarcodeScan(e) {
  // تجاهل مفاتيح التحكم
  if (['Control', 'Alt', 'Shift', 'Meta', 'Tab'].includes(e.key)) {
    return;
  }

  // التعامل مع نهاية المسح عند الضغط على Enter
  if (e.key === 'Enter') {
    e.preventDefault();
    if (this.scannedInput.length > 0) {
      this.processScannedData(this.scannedInput);
    }
    this.scannedInput = ''; // أعد تعيين المخزن المؤقت
    return;
  }

  // ✨ --- المنطق الجديد يبدأ هنا --- ✨
  // عند أول حرف من عملية المسح، قم بالتركيز على حقل الإدخال
  if (this.scannedInput.length === 0) {
    this.searchQuery = ''; // امسح القيمة المرئية في الحقل لبدء مسح جديد
    this.$nextTick(() => {
      // استخدم $nextTick للتأكد من أن العنصر جاهز قبل التركيز عليه
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }
    });
  }
  // ✨ --- المنطق الجديد ينتهي هنا --- ✨

  // أضف الحرف إلى المخزن المؤقت الداخلي
  this.scannedInput += e.key;
  
  // قم أيضًا بتحديث حقل البحث المرئي لتقديم ملاحظات فورية للمستخدم
  this.searchQuery = this.scannedInput;

  // أعد تعيين المخزن المؤقت بعد فترة قصيرة من التأخير
  clearTimeout(this.scannedInputTimeout);
  this.scannedInputTimeout = setTimeout(() => {
    this.scannedInput = '';
    // لا تمسح حقل البحث المرئي هنا، اتركه للمستخدم
  }, 300); 
},

    // NEW: Processes the data received from the scanner
    async processScannedData(scannedValue) {
      console.log('Processing scanned data:', scannedValue);
      
      // الخطوة 1: قم بتحويل أي أرقام عربية شرقية إلى غربية (إنجليزية)
      let cleanedValue = this.convertNumerals(scannedValue);

      // الخطوة 2: حاول معالجة البيانات كـ JSON أولاً (للحفاظ على وظيفة مسح بطاقة التعريف)
      try {
        const jsonStringArray = JSON.parse(cleanedValue);
        
        this.buyerType = jsonStringArray[0];
        this.pinCheckStatus = true;
        this.pinCodeFromQR = jsonStringArray[2];

        await this.fetchCustomers();
        this.searchQuery = jsonStringArray[1];
        this.filterCustomers();
        
        if (this.filteredCustomers.length === 1) {
            this.selectCustomer(this.filteredCustomers[0]);
        }
        return; // اخرج من الدالة إذا نجحت معالجة JSON

      } catch (e) {
        // إذا فشل، هذا يعني أنه ليس JSON، وسنتعامل معه كنص عادي في الخطوات التالية
        console.log("Not a JSON barcode, treating as a simple ID.");
      }

      // الخطوة 3: إذا لم يكن JSON، قم باستخلاص الأرقام فقط من النص
      const extractedNumber = cleanedValue.replace(/\D/g, ''); // هذا التعبير يزيل كل ما هو ليس رقماً

      if (extractedNumber) {
        console.log('Extracted Number:', extractedNumber);
        // استخدم الرقم المستخلص للبحث عن الزبون
        this.searchQuery = extractedNumber;
        this.filterCustomers();
        
        // اختيار الزبون تلقائياً إذا كان هناك تطابق واحد فقط
        if (this.filteredCustomers.length === 1) {
          this.selectCustomer(this.filteredCustomers[0]);
        }
      } else {
        ElMessage.error("لم يتم العثور على أرقام في الباركود الممسوح.");
      }
    },
    async openBillDailog(billNo) {
      let htmlContent = `
        <style>
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid black; padding: 5px; text-align: center; }
            p { text-align: center; }
        </style>
        <div>
        <center>
            <img style='width:120px;height:50px;' src='${require('@/assets/img/logo-school.png')}' alt='invoice'>
        </center>
          <p>المشتري : ${this.selectedCustomer.name}</p>
            <p>رقم الفاتورة : ${billNo}</p>
            <p>نوع الشراء : ${this.selectedPaymentMethod}</p>
        </div>
        <table border='1' cellpadding='5' cellspacing='0'>
            <thead>
                <tr>
                    <th>الصنف</th>
                    <th>الكمية</th>
                    <th>سعر القطعه</th>
                    <th>السعر</th>
                </tr>
            </thead>
            <tbody>`;

      this.kitchenBillItems.forEach((element) => {
        htmlContent += `
                <tr>
                    <td>${element.name}</td>
                    <td>${element.quantity}</td>
                    <td>${element.meal_price}</td>
                    <td>${element.meal_price * element.quantity}</td>
                </tr>`;
      });

      htmlContent += `
            </tbody>
            <tfoot>
                <tr>
                    <td colspan='3' align='right'>Total</td>
                    <td>${this.totalPriceValue}</td>
                </tr>
            </tfoot>
        </table>`;

      ElMessageBox.confirm(
        htmlContent,
        {
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Print',
          cancelButtonText: 'Close',
          callback: (action) => {
            if (action === 'confirm') {
              this.printHtmlContent(htmlContent);
            }
          }
        }
      );
    },

    printHtmlContent(htmlContent) {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();

      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    },

    async selectedPaymentMethodChanged() {
      this.selectedCategory = null;
      this.meals = null;
      this.filteredMeals = null;
      this.fetchMeals();
      this.kitchenBillItems = [];
      if (this.selectedPaymentMethod == 'wallet' || this.selectedPaymentMethod == 'cash') {
        this.categories = this.allcategories;
      }

      if (this.buyerType == 'student') {
        if (this.selectedCustomer.meal_fees.length > 0 && this.selectedPaymentMethod != 'wallet' && this.selectedPaymentMethod != 'cash') {
          if (this.selectedCustomer.meal_fees.length == 2) {
            this.categories = this.breakFastAndlunchCategories;
          } else if (this.selectedCustomer.meal_fees.length == 1) {
            if (this.selectedCustomer.meal_fees[0].id == 100)
              this.categories = this.breakFastCategory;
            if (this.selectedCustomer.meal_fees[0].id == 200)
              this.categories = this.lunchCategory;
          }
        }
      }
    },

    async fetchCategories() {
      const response = await api.get('/categories');
      this.categories = response.data;
      this.allcategories = this.categories;
    },

    async fetchCustomers() {
      this.pinCodeFromQR = "";
      this.pinCheckStatus = false;
      this.kitchenBillItems = [];
      this.selectedCustomer = null;
      this.searchQuery = '';
      this.mealSearchQuery = '';
      this.customers = "";
      this.filteredCustomers = "";
      this.paymentMethods = "";
      this.selectedPaymentMethod = "";
      if (this.buyerType != 'visitor') {
        const endpoint = this.buyerType === 'student'
          ? '/students-customers'
          : '/employees-customers';

        try {
          const response = await api.get(endpoint);
          this.customers = response.data;
          this.filteredCustomers = response.data;
        } catch (error) {
          console.error('Error fetching customers:', error);
        }
      } else if (this.buyerType == 'visitor') {
        this.customers = this.visitorData;
        this.filteredCustomers = this.visitorData;
      }
    },

    async fetchMeals() {
      try {
        const response = await api.get('/meals');
        this.meals = response.data;
        this.meals = this.meals.filter(meal => !this.restrictedMealIds.includes(meal.id));
        this.filterMeals();
      } catch (error) {
        console.error('Error fetching meals:', error);
      }
    },

    async filterCustomers() {
      if (!this.customers) return;
      const query = this.searchQuery.toLowerCase();
      this.filteredCustomers = this.customers.filter(customer => {
        return (
          customer.name.toLowerCase().includes(query) ||
          customer.id.toString() == query
        );
      });
    },

    async filterMeals() {
      const query = this.mealSearchQuery.toLowerCase();
      const theSelectedCategory = this.selectedCategory;
      this.filteredMeals = this.meals.filter(meal => {
        const isItInSelectedCategory = theSelectedCategory ? meal.category_id === theSelectedCategory : true;
        const isRestrictedMeal = this.restrictedMealIds.includes(meal.id);
        const matchesSearchQuery = meal.name.toLowerCase().includes(query);
        if (this.selectedCustomer && this.selectedCustomer.type === 'student') {
          return !isRestrictedMeal && matchesSearchQuery && isItInSelectedCategory;
        }
        return matchesSearchQuery && isItInSelectedCategory;
      });
    },

    selectCustomer(customer) {
      var conntenue = false;
      if (this.pinCheckStatus) {
        if (this.buyerType == 'student') {
          if (customer.parent.pin_code == this.pinCodeFromQR)
            conntenue = true;
        } else if (this.buyerType == 'employee') {
          if (customer.pin == this.pinCodeFromQR)
            conntenue = true;
        }
      } else {
        conntenue = true;
      }
      if (conntenue) {
        this.selectedCategory = "";
        this.meals = [];
        this.filteredMeals = [];
        this.selectedCustomer = customer;
        this.kitchenBillItems = [];
        this.paymentMethods = Array();
        this.selectedPaymentMethod = "";
        this.categories = this.allcategories;
        if (this.buyerType == 'student') {
          if (this.selectedCustomer.meal_fees.length > 0) {
            this.paymentMethods.push({ label: 'اشتراك', value: 'subscription' });
            if (this.selectedCustomer.meal_fees.length == 2) {
              this.categories = this.breakFastAndlunchCategories;
            } else if (this.selectedCustomer.meal_fees.length == 1) {
              if (this.selectedCustomer.meal_fees[0].id == 100)
                this.categories = this.breakFastCategory;
              if (this.selectedCustomer.meal_fees[0].id == 200)
                this.categories = this.lunchCategory;
            }
          }
          if (this.selectedCustomer.parent != null) {
            if (this.selectedCustomer.parent.wallet != null)
              this.paymentMethods.push({ label: 'محفظة', value: 'wallet' });
          }
        }
        if (this.buyerType == 'employee') {
          if (this.selectedCustomer.wallet != null)
            if (this.selectedCustomer.wallet.balance > 0) {
              this.paymentMethods.push({ label: 'محفظة', value: 'wallet' });
            }
        }
        this.restrictedMealIds = [];
        if (customer.student_restricted_meal) {
          for (let i = 0; i < customer.student_restricted_meal.length; i++) {
            this.restrictedMealIds.push(customer.student_restricted_meal[i].meal_id);
          }
        }
        this.fetchMeals();
        this.paymentMethods.push({ label: 'نقدي', value: 'cash' });
        if (this.paymentMethods.length > 0) {
          this.selectedPaymentMethod = this.paymentMethods[0].value;
        }
      } else {
        alert('البطاقة غير صالحه');
      }
    },

    addToBill(meal) {
      const existingItem = this.kitchenBillItems.find(item => item.meal_id === meal.id);
      if (existingItem) {
        if (this.selectedPaymentMethod == 'subscription' && existingItem.quantity < 1 && this.kitchenBillItems.length < 1) {
          existingItem.quantity++;
        } else if (this.selectedPaymentMethod == 'wallet' || this.selectedPaymentMethod == 'cash') {
          existingItem.quantity++;
        }
      } else {
        if (this.selectedPaymentMethod == 'subscription' && this.kitchenBillItems.length < 1) {
          this.kitchenBillItems.push({
            meal_id: meal.id,
            name: meal.name,
            meal_price: meal.price,
            category_id: meal.category_id,
            quantity: 1,
          });
        } else if (this.selectedPaymentMethod == 'wallet' || this.selectedPaymentMethod == 'cash') {
          this.kitchenBillItems.push({
            meal_id: meal.id,
            name: meal.name,
            meal_price: meal.price,
            category_id: meal.category_id,
            quantity: 1,
          });
        }
      }
    },

    removeFromBill(mealId) {
      const index = this.kitchenBillItems.findIndex(item => item.meal_id === mealId);
      if (index !== -1) {
        this.kitchenBillItems.splice(index, 1);
      }
    },

    ignoreError() {
      const debounce = (callback, delay) => {
        let tid;
        return function (...args) {
          const ctx = self;
          tid && clearTimeout(tid);
          tid = setTimeout(() => {
            callback.apply(ctx, args);
          }, delay);
        };
      };
      const _ = window.ResizeObserver;
      window.ResizeObserver = class ResizeObserver extends _ {
        constructor(callback) {
          callback = debounce(callback, 20);
          super(callback);
        }
      };
    },

    async submitBill() {
      let billData = {};
      if (this.buyerType == 'student' && this.selectedPaymentMethod == 'subscription') {
        billData = {
          buyer_id: this.selectedCustomer.id,
          buyer_type: this.buyerType,
          billTotalPrice: this.totalPriceValue,
          PaymentMethod: this.selectedPaymentMethod,
          category_id: this.kitchenBillItems[0].category_id,
          items: this.kitchenBillItems.map(item => ({
            meal_id: item.meal_id,
            quantity: item.quantity,
            meal_price: item.meal_price,
          })),
        };
      } else {
        billData = {
          buyer_id: this.selectedCustomer.id,
          buyer_type: this.buyerType,
          billTotalPrice: this.totalPriceValue,
          PaymentMethod: this.selectedPaymentMethod,
          category_id: '',
          items: this.kitchenBillItems.map(item => ({
            meal_id: item.meal_id,
            quantity: item.quantity,
            meal_price: item.meal_price,
          })),
        };
      }
      try {
        const response = await api.post('/buying-from-kitchen', billData);
        if (response.status == 201) {
          this.openBillDailog(response.data.bill.bill_number);
          this.fetchCustomers();
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message ||
                         error.response?.data?.errors?.message ||
                         'An unexpected error occurred.';
        ElNotification({
          title: 'حدث خطأ',
          message: errorMessage,
          position: 'top-left',
          duration: 0,
          type: 'error',
        });
      }
    },
  },
  mounted() {
    this.fetchCustomers();
    this.fetchCategories();
    this.ignoreError();
    window.addEventListener('keydown', this.handleBarcodeScan);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleBarcodeScan);
    clearTimeout(this.scannedInputTimeout); // Clear timeout on component destruction
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
.table-wrapper {
  max-height: 179px;
  height: 179px;
  overflow-x: auto;
  overflow-y: auto;
}
.el-card__body {
  padding: 10px !important;
}
.el-radio-button {
  margin: 0px !important;
}
</style>